import { storeName } from './types';

const getData = state => state[storeName] || [];
const getDeliveryModes = state => getData(state).data || [];
const getDeliveryCodeByType = (state, type) => {
    const deliveryMode = getDeliveryModes(state).find(mode => mode.type === type);
    return deliveryMode ? deliveryMode.code : null;
};

const getDeliveryModeByCode = (state, deliveryModeId) =>
    getDeliveryModes(state).find(({ code }) => code === deliveryModeId) || {};

const hasDeliveryModeFeature = (state, code, feature) => {
    const { supportedFeatures = [] } = getDeliveryModeByCode(state, code);
    return !!supportedFeatures.find(({ code }) => code === feature);
};

const getCodeOfHomeDeliveryMode = state => getDeliveryCodeByType(state, 'HOME');
const getCodeOfPostPointDeliveryMode = state => getDeliveryCodeByType(state, 'POST_POINT');
const getCodeOfPickupInStoreDeliveryMode = state => getDeliveryCodeByType(state, 'PICKUP_IN_STORE');
const getCodeOfPickupExpressDeliveryMode = state => getDeliveryCodeByType(state, 'PICKUP_EXPRESS');
const getCheckRts = state => getData(state).checkRts;
const getRtsAvailable = state => {
    return getData(state).rtsAvailable;
};
const getDeliveryBlocked = state => getData(state).deliveryBlocked;
const getDeliveryMode = state =>
    state.checkout ? (state.checkout.data ? state.checkout.data.deliveryMode : null) : null;

export default {
    getDeliveryModes,
    getCodeOfHomeDeliveryMode,
    getCodeOfPostPointDeliveryMode,
    getCodeOfPickupInStoreDeliveryMode,
    getCodeOfPickupExpressDeliveryMode,
    getCheckRts,
    getRtsAvailable,
    getDeliveryBlocked,
    hasDeliveryModeFeature,
    getDeliveryMode,
};
